import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
let SettingsApiService = class SettingsApiService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this.endpointUrl = '/settings/config';
    }
    list(params = {}) {
        return this._httpClient.get(`${this.endpointUrl}`, params);
    }
    batchUpdate(section, body) {
        return this._httpClient.put(`${this.endpointUrl}/batch-update/${section}`, body);
    }
};
SettingsApiService.ctorParameters = () => [
    { type: HttpClient }
];
SettingsApiService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [HttpClient])
], SettingsApiService);
export { SettingsApiService };
